module.exports = __webpack_public_path__ + "static/life-continero-work-small-3794552d0d55923a37020b2e445476ea.jpg";